import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  constructor(private http: HttpClient ) { }

  getUserMenu(): Observable<any> {

    return this.http.get(environment.baseUrl + 'Login/getAccountInfo').pipe(map(res => res));
  
  }
}
